<!-- 页面头部 -- 搜索功能列表 -->
<template>
	<div class="search">
		<div class="searchItem" v-for="(item, index) in searchShowData" :key="index">
			<!-- <slot name="auth"></slot> -->
			<el-input
				v-if="item.type == 'input'"
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
			/>
			<el-input
				v-if="item.type == 'phone'"
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				type="number"
				clearable
			/>
			<el-input-number
				v-if="item.type == 'number'"
				:controls="false"
				:placeholder="item.label"
				v-model="searchForm[item.model]"
				clearable
			>
			</el-input-number>
			<el-date-picker
				v-if="item.type == 'date'"
				v-model="searchForm[item.model]"
				type="daterange"
				range-separator="至"
				:start-placeholder="item.startP ? item.startP : '开始时间'"
				:end-placeholder="item.endP ? item.endP : '结束时间'"
				:placeholder="item.label"
				format="YYYY-MM-DD"
				value-format="YYYY-MM-DD"
				clearable
				:picker-options="item.pickerOptions ? item.pickerOptions : []"
				@change="(e) => emit('dateChange', e, item)"
				@clear="onClear(e, item)"
			/>
			<el-date-picker
				v-if="item.type == 'month'"
				v-model="searchForm[item.model]"
				type="month"
				:placeholder="item.label"
				format="YYYY-MM"
				value-format="YYYY-MM"
				clearable
			/>
			<el-date-picker
				v-if="item.type == 'months'"
				v-model="searchForm[item.model]"
				type="month"
				:placeholder="item.label"
				format="YYYY-MM"
				value-format="YYYY-MM"
			/>

			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				style="width: 220px"
				v-if="item.type == 'picker' && item.select == '1'"
			>
				<el-option v-for="el in item.option" :key="el" :label="el" :value="el" />
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				style="width: 220px"
				v-if="item.type == 'picker' && item.select == '2' && !item.noclear"
			>
				<el-option v-for="item in item.option" :key="item.id" :label="item.name" :value="item.id" />
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				filterable
				style="width: 220px"
				v-if="item.type == 'picker' && item.select == '2' && item.noclear"
			>
				<el-option v-for="item in item.option" :key="item.id" :label="item.name" :value="item.id" />
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				style="width: 220px"
				clearable
				filterable
				v-if="item.type == 'picker' && item.select == '3'"
			>
				<el-option
					v-for="item in item.option"
					:key="item.a_id"
					:label="item.a_username"
					:value="item.a_id"
				/>
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				v-if="item.type == 'picker' && item.select == '4'"
			>
				<el-option
					v-for="item in item.option"
					:key="item.id"
					:label="item.name"
					:value="item.name"
				/>
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				v-if="item.type == 'picker' && item.select == '5'"
			>
				<el-option
					v-for="item in item.option"
					:key="item.po_id"
					:label="item.po_name"
					:value="item.po_id"
				/>
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				v-if="item.type == 'picker' && item.select == '6'"
			>
				<el-option
					v-for="item in item.option"
					:key="item.id"
					:label="item.title"
					:value="item.id"
				/>
			</el-select>
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				v-if="item.type == 'picker' && item.select == '7'"
			>
				<el-option v-for="item in item.option" :key="item.id" :label="item.name" :value="item.id" />
			</el-select>
			<el-cascader
				v-model="searchForm[item.model]"
				:options="cascaderOptions"
				:props="cascaderProps"
				clearable
				filterable
				:show-all-levels="false"
				style="width: 220px"
				placeholder="请选择部门"
				v-if="item.type == 'dept'"
			/>
			<el-cascader
				v-model="searchForm[item.model]"
				:options="centerOptions"
				:props="centerProps"
				clearable
				filterable
				:show-all-levels="false"
				style="width: 220px"
				placeholder="请选择学习中心"
				v-if="item.type == 'study'"
			/>
			<!-- <el-cascader
				v-model="searchForm[item.model]"
				:options="teacherOptions"
				:props="centerProps"
				clearable
				style="width: 220px"
				placeholder="请选择老师"
				v-if="item.type == 'emp'"
			/> -->
			<el-select
				v-model="searchForm[item.model]"
				:placeholder="item.label"
				clearable
				filterable
				v-if="item.type == 'emp'"
			>
				<el-option
					v-for="item in teacherOptions"
					:key="item.id"
					:label="item.name"
					:value="item.id"
				/>
			</el-select>
		</div>
		<div class="searchBtn">
			<slot name="default"></slot>
		</div>
	</div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue'
import { getDepts, getStudys, getEmps } from '@/api/public'
import { get_emps } from '@/api/common.js'
import config from '@/config/config'
const { proxy } = getCurrentInstance()
const props = defineProps({
	searchShowData: {
		type: Object,
		default: []
	},
	searchForm: {
		type: Object,
		default: {}
	}
})
const emit = defineEmits(['againTime', 'dateChange'])

const cascaderOptions = ref([]) // 部门 -- 选项数据
const centerOptions = ref([]) // 学习中心 -- 选项数据
const teacherOptions = ref([]) // 老师 -- 选项数据

const cascaderProps = ref({
	checkStrictly: true,
	expandTrigger: 'hover',
	value: 'id',
	label: 'name',
	children: 'children'
})
const centerProps = ref({
	checkStrictly: true,
	expandTrigger: 'hover',
	value: 'id',
	label: 'name',
	children: 'children'
})

/**
 * 处理清除操作
 *
 * @param {Event} e - 事件对象
 * @param {*} val - 清除的值
 * @emits againTime - 触发重新设置时间事件
 */
const onClear = (e, val) => {
	emit('againTime')
}
// 获取部门联级选择数据
const queryCascaderData = () => {
	getDepts().then((res) => {
		if (res.code == 200) {
			if (!res.flag) {
				let params = JSON.stringify(res.data)
				localStorage.setItem(config.DEPT, params)
				cascaderOptions.value = res.data
			} else {
				cascaderOptions.value = res.data
			}
		} else {
			proxy.$modal.msgError(res.msg)
		}
	})
}

// 获取学习中心联级选择数据
const queryCenterData = () => {
	getStudys().then((res) => {
		if (res.code == 200) {
			if (!res.flag) {
				let params = JSON.stringify(res.data)
				localStorage.setItem(config.STUDY, params)
				centerOptions.value = res.data
			} else {
				centerOptions.value = res.data
			}
		} else {
			proxy.$modal.msgError(res.msg)
		}
	})
}

// 获取老师数据
const queryTeacherData = () => {
	getEmps().then((res) => {
		if (res.code == 200) {
			if (!res.flag) {
				let params = JSON.stringify(res.data)
				localStorage.setItem(config.EMP, params)
				teacherOptions.value = res.data
			} else {
				teacherOptions.value = res.data
			}
		} else {
			proxy.$modal.msgError(res.msg)
		}
	})
}

queryCascaderData()
queryCenterData()
queryTeacherData()
</script>

<style lang="scss" scoped>
.search {
	display: flex;
	flex-wrap: wrap;
	// justify-content: space-between;
	.searchItem {
		min-width: 220px;
		margin: 0 20px 5px 0;
	}
}
</style>
